export interface NumberMap<T> {
  [key: number]: T
}

export interface StringMap<T> {
  [key: string]: T
}

/**
 * Map an array to an object
 * @param array Array to map
 * @param key Property that will be used as the key or a function that is invoked to set items
 */
export function toMap<T>(
  array: T[],
  key: keyof T | ((item: T, map: StringMap<T>) => void)
): StringMap<T> {
  const map: StringMap<T> = {}

  for (const item of array) {
    if (typeof key === 'string') {
      defaultAssignFunction(item, map, key)
    } else if (typeof key === 'function') {
      key(item, map)
    }
  }

  return map
}

export function toGroupMap<T>(array: T[], key: keyof T): StringMap<T[]> {
  const map: StringMap<T[]> = {}

  for (const item of array) {
    arrayAssignFunction(item, map, key)
  }

  return map
}

function arrayAssignFunction<T>(item: T, map: StringMap<T[]>, key: keyof T): void {
  // It will only work with strings, numbers and symbols but I don't know how to express this in typescript so let's just cast it to unknown and then to string
  const valueAsKey = (item[key] as unknown) as string

  if (map[valueAsKey] === undefined) {
    map[valueAsKey] = []
  }

  map[valueAsKey].push(item)
}

function defaultAssignFunction<T>(item: T, map: StringMap<T>, key: keyof T): void {
  // It will only work with strings, numbers and symbols but I don't know how to express this in typescript so let's just cast it to unknown and then to string
  const valueAsKey = (item[key] as unknown) as string

  map[valueAsKey] = item
}
